import { workspaceMetaDataLoadEpicReducer, } from './WorkspaceSettingsManagement/ducks/GetWorkspaceMetaData.ducks';
import { workspaceProxyStatusUpdateEpicReducer, } from './WorkspaceSettingsManagement/ducks/UpdateWorkspaceProxyStatus.ducks';
import { workspaceProxyStatusGetEpicReducer, } from './WorkspaceSettingsManagement/ducks/GetWorkspaceProxyStatus.ducks';
import { workspaceSecurityGroupsPutEpicReducer, } from './WorkspaceSettingsManagement/ducks/PutWorkspaceSecurityGroups.ducks';
import { workspaceServicePrincipalsPutEpicReducer, } from './WorkspaceSettingsManagement/ducks/PutWorkspaceServicePrincipals.ducks';
import { workspaceServicePrincipalsGetEpicReducer, } from './WorkspaceSettingsManagement/ducks/GetWorkspaceServicePrincipals.ducks';
import { workspaceSecurityGroupsDeleteEpicReducer, } from './WorkspaceSettingsManagement/ducks/DeleteWorkspaceSecurityGroups.ducks';
import { workspaceServicePrincipalsDeleteEpicReducer, } from './WorkspaceSettingsManagement/ducks/DeleteWorkspaceSP.ducks';
import { workspaceSecurityGroupsGetEpicReducer, } from './WorkspaceSettingsManagement/ducks/GetWorkspaceSGs.ducks';
import { defaultReducerState as workspaceMetaData } from './WorkspaceSettingsManagement/ducks/GetWorkspaceMetaData.ducks';
import { defaultReducerState as getWorkspaceProxyStatusResult } from './WorkspaceSettingsManagement/ducks/GetWorkspaceProxyStatus.ducks';
import { defaultReducerState as updateWorkspaceProxyStatusResult } from './WorkspaceSettingsManagement/ducks/UpdateWorkspaceProxyStatus.ducks';
import { defaultReducerState as getWorkspaceServicePrincipalsResult } from './WorkspaceSettingsManagement/ducks/GetWorkspaceServicePrincipals.ducks';
import { defaultReducerState as putWorkspaceSecurityGroupsResult } from './WorkspaceSettingsManagement/ducks/PutWorkspaceSecurityGroups.ducks';
import { defaultReducerState as getWorkspaceSecurityGroupsResult } from './WorkspaceSettingsManagement/ducks/GetWorkspaceSGs.ducks';
import { defaultReducerState as putWorkspaceServicePrincipalsResult } from './WorkspaceSettingsManagement/ducks/PutWorkspaceServicePrincipals.ducks';
import { defaultReducerState as deleteWorkspaceSecurityGroupsResult } from './WorkspaceSettingsManagement/ducks/DeleteWorkspaceSecurityGroups.ducks';
import { defaultReducerState as deleteWorkspaceSPResult } from './WorkspaceSettingsManagement/ducks/DeleteWorkspaceSP.ducks';
import { createAction } from 'typesafe-actions';
import { defaultReducerState as getUAAAccessResult, uaaAccessGetEpicReducer, } from './WorkspaceSettingsManagement/ducks/GetUAAAccess.ducks';
export var ROOT_REDUCER_KEYS;
(function (ROOT_REDUCER_KEYS) {
    ROOT_REDUCER_KEYS["METADATA"] = "metaData";
    ROOT_REDUCER_KEYS["PROXY_STATUS"] = "proxyStatus";
    ROOT_REDUCER_KEYS["WORKSPACE_SG"] = "workspaceSG";
    ROOT_REDUCER_KEYS["WORKSPACE_SP"] = "workspaceSP";
    ROOT_REDUCER_KEYS["GLOBAL"] = "global";
})(ROOT_REDUCER_KEYS || (ROOT_REDUCER_KEYS = {}));
export var GLOBAL_ACTION_KEYS;
(function (GLOBAL_ACTION_KEYS) {
    GLOBAL_ACTION_KEYS["GET_SP"] = "getSP";
    GLOBAL_ACTION_KEYS["GET_SG"] = "getSG";
    GLOBAL_ACTION_KEYS["GET_UAA_ACCESS"] = "getUAAAccess";
})(GLOBAL_ACTION_KEYS || (GLOBAL_ACTION_KEYS = {}));
export var METADATA_ACTION_KEYS;
(function (METADATA_ACTION_KEYS) {
    METADATA_ACTION_KEYS["GET"] = "get";
})(METADATA_ACTION_KEYS || (METADATA_ACTION_KEYS = {}));
export var PROXY_STATUS_ACTION_KEYS;
(function (PROXY_STATUS_ACTION_KEYS) {
    PROXY_STATUS_ACTION_KEYS["GET"] = "get";
    PROXY_STATUS_ACTION_KEYS["PUT"] = "put";
})(PROXY_STATUS_ACTION_KEYS || (PROXY_STATUS_ACTION_KEYS = {}));
export var WORKSPACE_SG_ACTION_KEYS;
(function (WORKSPACE_SG_ACTION_KEYS) {
    WORKSPACE_SG_ACTION_KEYS["DELETE"] = "delete";
    WORKSPACE_SG_ACTION_KEYS["PUT"] = "put";
})(WORKSPACE_SG_ACTION_KEYS || (WORKSPACE_SG_ACTION_KEYS = {}));
export var WORKSPACE_SP_ACTION_KEYS;
(function (WORKSPACE_SP_ACTION_KEYS) {
    WORKSPACE_SP_ACTION_KEYS["DELETE"] = "delete";
    WORKSPACE_SP_ACTION_KEYS["PUT"] = "put";
})(WORKSPACE_SP_ACTION_KEYS || (WORKSPACE_SP_ACTION_KEYS = {}));
export const getWPSDefaultState = () => ({
    [ROOT_REDUCER_KEYS.GLOBAL]: {
        [GLOBAL_ACTION_KEYS.GET_SG]: getWorkspaceSecurityGroupsResult,
        [GLOBAL_ACTION_KEYS.GET_SP]: getWorkspaceServicePrincipalsResult,
        [GLOBAL_ACTION_KEYS.GET_UAA_ACCESS]: getUAAAccessResult,
    },
    [ROOT_REDUCER_KEYS.METADATA]: {
        [METADATA_ACTION_KEYS.GET]: workspaceMetaData,
    },
    [ROOT_REDUCER_KEYS.PROXY_STATUS]: {
        [PROXY_STATUS_ACTION_KEYS.GET]: getWorkspaceProxyStatusResult,
        [PROXY_STATUS_ACTION_KEYS.PUT]: updateWorkspaceProxyStatusResult,
    },
    [ROOT_REDUCER_KEYS.WORKSPACE_SG]: {
        [WORKSPACE_SG_ACTION_KEYS.DELETE]: deleteWorkspaceSecurityGroupsResult,
        [WORKSPACE_SG_ACTION_KEYS.PUT]: putWorkspaceSecurityGroupsResult,
    },
    [ROOT_REDUCER_KEYS.WORKSPACE_SP]: {
        [WORKSPACE_SP_ACTION_KEYS.DELETE]: deleteWorkspaceSPResult,
        [WORKSPACE_SP_ACTION_KEYS.PUT]: putWorkspaceServicePrincipalsResult,
    },
});
const resetDeleteWorkspaceSGsName = 'RESET_DELETE_WORKSPACE_SGS';
export const resetDeleteWorkspaceSGs = createAction(resetDeleteWorkspaceSGsName, (action) => () => action());
const resetDeleteWorkspaceSPName = 'RESET_DELETE_WORKSPACE_SP';
export const resetDeleteWorkspaceSP = createAction(resetDeleteWorkspaceSPName, (action) => () => action());
export const WPSReducer = (state = getWPSDefaultState(), 
/**
 * TODO redux cleanup
 * Typescript should be able to infer the type within based on the switch statement
 */
actionResult) => {
    state = workspaceMetaDataLoadEpicReducer.reduxChange(state, actionResult);
    state = workspaceProxyStatusUpdateEpicReducer.reduxChange(state, actionResult);
    state = workspaceProxyStatusGetEpicReducer.reduxChange(state, actionResult);
    state = workspaceSecurityGroupsPutEpicReducer.reduxChange(state, actionResult);
    state = workspaceServicePrincipalsPutEpicReducer.reduxChange(state, actionResult);
    state = workspaceServicePrincipalsGetEpicReducer.reduxChange(state, actionResult);
    state = workspaceSecurityGroupsDeleteEpicReducer.reduxChange(state, actionResult);
    state = workspaceServicePrincipalsDeleteEpicReducer.reduxChange(state, actionResult);
    state = workspaceSecurityGroupsGetEpicReducer.reduxChange(state, actionResult);
    state = uaaAccessGetEpicReducer.reduxChange(state, actionResult);
    switch (actionResult.type) {
        case resetDeleteWorkspaceSGsName:
            return Object.assign(Object.assign({}, state), { workspaceSG: Object.assign(Object.assign({}, state.workspaceSG), { delete: deleteWorkspaceSecurityGroupsResult }) });
        case resetDeleteWorkspaceSPName:
            return Object.assign(Object.assign({}, state), { workspaceSP: Object.assign(Object.assign({}, state.workspaceSP), { delete: deleteWorkspaceSPResult }) });
    }
    return state;
};

//# sourceMappingURL=workspaceSettingsReducer.js.map
